import { Track } from '../../../classes/track'
import { TrackFields } from '../../../constants'

const startsWithNumberRegex = /(^\(?\d{2,3}\)?(\s|\.|-)(\.|-)?)/

export function findTracksThatStartWithNumbers(tracks: Track[]) {
  return tracks.filter(t => /\D+/.test(t.title) && startsWithNumberRegex.test(t.title))
}

export function removeNumberPrefix(track: any, values: any[]): string {
  const field: TrackFields = values[0]
  let s = track[field]

  const group = startsWithNumberRegex.exec(s)

  if (group) {
    s = s.replace(group[1], '').trim()
  }

  return s
}
